import dayjs, { type Dayjs } from '@/utilities/dayjs-config'
import { computed } from 'nanostores'
import { $menus } from './stores'

export const $getMenu = computed(
  [$menus],
  (menus) => (week: Dayjs, zip: string) => {
    const startOfWeek = dayjs(week).startOf('week')
    const menuKey = `${startOfWeek.format('YYYY-MM-DD')}${zip}`

    return menus[menuKey]
  },
)
